import type { PropsWithChildren } from 'react';

import { twMerge } from 'tailwind-merge';

type MediaContainerProps = PropsWithChildren<{ className?: string }>;

export function MediaContainer({ children, className }: MediaContainerProps) {
  return (
    <section
      className={twMerge(
        'border-c-border col-span-12 mt-6 flex max-w-full flex-wrap gap-4 rounded-xl border border-dashed p-4 pt-6',
        className
      )}
    >
      {children}
    </section>
  );
}
